module.exports = __webpack_public_path__ + "static/media/button-reject-request.5999c2ae.svg";